module.exports = function getResource(label, vars = []) {
    const resources = {
        resumeSubscription: 'Reprendre l’abonnement',
        qty: 'Qté',
        deliveryEvery: 'Livraison chaque',
        shippingAddress: 'Adresse de livraison',
        paymentMethod: 'Mode de paiement',
        nextShipment: 'Prochaine livraison le',
        item: 'ARTICLE',
        resume: 'Reprendre',
        cancel: 'Annuler',
        editMessage: 'Vous pouvez apporter des modifications à votre abonnement après avoir repris les livraisons.',
        paymentMessage: 'En vous inscrivant, la carte de votre mode de paiement par défaut inscrit au dossier sera facturée.',
        notRated: 'Aucune note',
        oneReview: 'Un commentaire',
        yearlySavings: 'économies annuelles'
    };

    return resources[label];
};
